import * as actionTypes from './userActionTypes';

export const login = (username) => ({type: actionTypes.LOGIN, username:username});
export const logout = () => ({type: actionTypes.LOGOUT});